// Keep the original fetch, then overwrite window.fetch with our fixer.
// The fixer must call this original one at the end — not window.fetch —
// so we don't loop on our own function.
const nativeFetch = window.fetch.bind(window);

// with proxy being used potree's default urls are not working, so we need to fix them
// issue is, proxy url format does not match the potree's default urls
// intercept fetch calls and fix the urls
// broken:  …/metadata.json?token=abc&authorizer_prefix=…/../octree.bin
// fixed:   …/octree.bin?token=abc&authorizer_prefix=…
function installPotreeFetchFix() {
  if (window.__potreeProxyFetch) return;
  window.__potreeProxyFetch = true;
  window.fetch = (url, init) => {
    if (url?.includes?.('cornis-proxy-service.cornis.fr')) {
      const q = url.indexOf('?');
      const tail = q >= 0 && url.slice(q).match(/(\/\.\.\/.+)$/);
      if (tail) {
        url = new URL(url.slice(0, q) + tail[1]).toString() + url.slice(q, -tail[1].length);
      }
    }
    return nativeFetch(url, init);
  };
}

// Called from PotreeViewer when opening a 3D layer (/3D): enable the proxy URL
// fix, then ask Potree to load the Potree file from the proxied metadata.json.
export function loadPotreeLayer(url, name, onLoaded) {
  installPotreeFetchFix();
  return window.Potree.loadPointCloud(url, name, onLoaded);
}

// Once Potree has loaded the file, attach it to the viewer scene so it renders.
export function addPotreeLayerToScene(scene, potreeNode) {
  return scene.addPointCloud(potreeNode);
}

// Potree's onLoaded callback receives an event object; the viewer only needs the loaded node.
export function getPotreeNodeFromLoadEvent(event) {
  return event.pointcloud;
}
